import React from 'react';
import '../App.css';
import {toast} from "react-toastify";

const SocialIcons: React.FC = () => {
    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText("sungkyustream@gmail.com");
            toast.success("이메일 주소가 클립보드에 복사되었습니다!", {autoClose: 1000, hideProgressBar: true});
        } catch (e) {
            toast.error("이메일 주소 복사에 실패했습니다. 다시 시도해주세요.", {autoClose: 1000, hideProgressBar: true});
        }
    };

    return (
        <div className="social-icon">
            <img src={process.env.PUBLIC_URL + '/email-icon.svg'} alt="Email"
                 onClick={(e) => copyEmail()}/>
            <a href="https://x.com/sungkyustream" target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL + '/x-logo.svg'} alt="X" />
            </a>
            <a href="https://pf.kakao.com/_zfixgn" target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL + '/kakao-logo.svg'} alt="kakao" />
            </a>
        </div>
    );
};

export default SocialIcons;